import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cart",
  "use": "icon-cart-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 18 18\" id=\"icon-cart\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.559.53h-3.16l-.77 11.6a5 5 0 0 0 4.99 5.34h7.38a5 5 0 0 0 4.99-5.33L17.209.53H4.559Zm0 1h-2.22l-.71 10.67a4 4 0 0 0 3.99 4.27h7.38a4 4 0 0 0 4-4.27l-.72-10.67h-2.22v.63a4.75 4.75 0 0 1-9.5 0v-.63Zm8.5 0h-7.5v.63a3.75 3.75 0 1 0 7.5 0v-.63Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol